// biome-ignore format: CSS import must stay at the top for proper style cascade
import "./style/main.css";
// this line is intentionally left blank to separate the CSS import from the rest of the code
import {
  SPLASH_DELAY_MS,
  StartupSplashHost,
  StartupSplashProvider,
  StartupStageReporter,
} from "@atoms/atom-client";
import { LoadingSplash } from "@atoms/atom-components";
import { projectBranding } from "@project/frontend-provision/branding";
import { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";

const AppRoot = lazy(() => import("./AppRoot"));

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element not found");
}

createRoot(root).render(
  <StartupSplashProvider>
    <StartupSplashHost
      splashScreen={<LoadingSplash appName={projectBranding.appName} />}
      delayMs={SPLASH_DELAY_MS}
    />
    <Suspense fallback={<StartupStageReporter stage="bundle" />}>
      <AppRoot />
    </Suspense>
  </StartupSplashProvider>,
);
